import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/Input';
import { ErrorState, EmptyState, Skeleton } from '../components/States';
import { useCountries } from '../hooks/useWiki';
export function CountriesPage() {
  const [search, setSearch] = useState('');
  const nav = useNavigate();
  const query = useCountries();
  if (query.isLoading)
    return (
      <div className="page">
        <Skeleton />
      </div>
    );
  if (query.error)
    return (
      <div className="page">
        <ErrorState
          message="Country intelligence could not be loaded."
          retry={() => void query.refetch()}
        />
      </div>
    );
  const countries = (query.data ?? []).filter((x) =>
    x.name.toLowerCase().includes(search.toLowerCase()),
  );
  return (
    <div className="page countries-page">
      <section className="page-intro">
        <div>
          <span className="eyebrow">Country intelligence</span>
          <h1>Countries</h1>
          <p>Military profiles and community-maintained weapons encyclopaedia.</p>
        </div>
      </section>
      <Input
        label="Search countries"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by country"
      />
      {countries.length === 0 ? (
        <EmptyState title="No countries found" message="Try a different search term." />
      ) : (
        <div className="country-grid">
          {countries.map((country) => (
            <button
              className="country-card"
              key={country.id}
              onClick={() => nav(`/countries/${country.id}`)}
            >
              <span>{country.flag}</span>
              <div>
                <h2>{country.name}</h2>
                <p>{country.stats.missile_force}</p>
                <small>{country.stats.uav_fleet} UAV fleet</small>
              </div>
              <b>OPEN →</b>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
